(function () {
  'use strict';
  function formatBRL(cents) {
    return (cents / 100).toLocaleString('pt-BR', {
      style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }
  function updateInstallment(container, variantPriceCents) {
    if (!container) return;
    var installments = parseInt(container.dataset.installments, 10) || 5;
    var valueEl = container.querySelector('[data-installment-value]');
    if (!valueEl) return;
    if (!variantPriceCents || variantPriceCents <= 0) { container.style.display = 'none'; return; }
    valueEl.textContent = formatBRL(Math.floor(variantPriceCents / installments));
    container.style.display = '';
  }
  function findScope(t) {
    return t.closest('product-info') || t.closest('.product') || t.closest('section[id*="MainProduct"]') || document;
  }
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant; if (!v) return;
    updateInstallment(findScope(e.target).querySelector('[data-installment-price]'), v.price);
  });
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('input[name="id"], select[name="id"]')) return;
    var form = input.closest('form'); if (!form) return;
    var scope = form.closest('product-info, section'); if (!scope) return;
    var s = scope.querySelector('script[type="application/json"][data-product-json], script[type="application/json"][id*="ProductJson"]');
    if (!s) return;
    try {
      var data = JSON.parse(s.textContent);
      var found = (data.variants || []).find(function (v) { return String(v.id) === String(input.value); });
      if (!found) return;
      updateInstallment(scope.querySelector('[data-installment-price]'), found.price);
    } catch (err) {}
  });
})();
